import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxSelectBoxModule } from 'devextreme-angular';
@Component({
  selector: 'dk-example',
  standalone: true,
  imports: [CommonModule, DxSelectBoxModule],
  templateUrl: './example.component.html',
  styleUrls: ['./example.component.scss'],
})
export class ExampleComponent {}
